module.exports = __webpack_public_path__ + "img/facebook.6a46b0b2.svg";